const Alls = [
  { id: "1", authName: "首页", path: "/home" },
//   { id: "2", authName: "论坛", path: "/forum" },
  { id: "3", authName: "二手车源", path: "/usedcarsource" },
  { id: "4", authName: "检车必看", path: "/inspectionmust" },
  { id: "5", authName: "加入我们", path: "/joinus" },
  { id: "6", authName: "关于我们", path: "/aboutus" }
];
const pricelist = [
  "不限",
  "3万以下",
  "3-5万",
  "5-7万",
  "7-9万",
  "9-12万",
  "12-16万",
  "20万以上"
];
const levelist = [
  {
    label: "紧凑型",
    value: "紧凑型"
  },
  {
    label: "SUV",
    value: "SUV"
  },
  {
    label: "MPV",
    value: "MPV"
  },
  {
    label: "跑车",
    value: "跑车"
  },
  {
    label: "皮卡",
    value: "皮卡"
  },
  {
    label: "中型车",
    value: "中型车"
  }
];
const hicleagelist = [
  {
    label: "1年内",
    value: "1"
  },
  {
    label: "3年内",
    value: "2"
  },
  {
    label: "5年内",
    value: "3"
  },
  {
    label: "8年内",
    value: "4"
  },
  {
    label: "8年以上",
    value: "5"
  }
];
const mileagelist = [
  {
    label: "1万KM内",
    value: "1"
  },
  {
    label: "3万KM内",
    value: "2"
  },
  {
    label: "5万KM内",
    value: "3"
  },
  {
    label: "8万KM内",
    value: "4"
  },
  {
    label: "8万KM以上",
    value: "5"
  }
];
const displacementlist = [
  {
    label: "1L以下",
    value: "1"
  },
  {
    label: "1-1.6L",
    value: "2"
  },
  {
    label: "1.6-2.0L",
    value: "3"
  },
  {
    label: "2.0-3.0L",
    value: "4"
  },
  {
    label: "3.0-4.0L",
    value: "5"
  },
  {
    label: "4.0L以上",
    value: "6"
  }
];
const gearboxlist = [
  {
    label: "手动",
    value: "手动"
  },
  {
    label: "自动",
    value: "自动"
  }
];
const Seatlist = [
  {
    label: "2座",
    value: "2"
  },
  {
    label: "4座",
    value: "4"
  },
  {
    label: "5座",
    value: "5"
  },
  {
    label: "6座",
    value: "6"
  },
  {
    label: "7座以上",
    value: "7"
  }
];

export {
  Alls,
  pricelist,
  levelist,
  hicleagelist,
  mileagelist,
  displacementlist,
  gearboxlist,
  Seatlist
};
